import CardSlot from '@/pages/dashboard/components/CardSlot';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import React, { useEffect, useMemo, useState } from 'react';
import { Segment } from 'tea-component';
import { useIntl } from 'umi';
import useStepOptions from "@/pages/dashboard/pages/funnel/_config/useStepOptions";
import { handleDownload } from '@/pages/dashboard/utils/utils';
import { getRegisterFunnelTends } from '@/pages/dashboard/services/funnel';
import Abnormal from '@/pages/dashboard/components/Abnormal';

import './index.scss';
import TextBubbles from '@/pages/home/components/TextBubbles';
import dataFormat from '@home/utils/dbDataFormat/dataFormat';
import { formatFunnelFilterValues } from '../../_config/utils';

const FunnelCard = (props: any) => {
  const { formValue, filterLoading, gameCode, pageType, isPoeDemo } = props;
  const stepOptions = useStepOptions(formValue);

  const { filterValue } = formValue || {};
  const { rangeTime } = filterValue || {};
  const { formatMessage } = useIntl();
  const [funnelOsValue, setFunnleOsValue] = useState<any>('total');
  const [stepData, setStepData] = useState([]);
  const [stepTootipData, setStepTootipData] = useState<any>({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (filterLoading) return;
    getFunnelData(funnelOsValue);
  }, [formValue, filterLoading]);

  const getFunnelData = (funnelOs: string) => {
    const { rangeTime, ...filters } = filterValue || {};
    const params = {
      game_code: gameCode,
      tab_type: funnelOs,
      period: 'daily',
      start_time: rangeTime?.[0],
      end_time: rangeTime?.[1],
      filters: formatFunnelFilterValues(filters),
    };
    setLoading(true);
    setError(false);
    getRegisterFunnelTends(params, pageType).then((data) => {
      setStepData(data?.list || []);
      setError(false);
    }).catch(() => {
      setError(true);
    }).finally(() => {
      setLoading(false);
    });
  };

  const funnelOsValueChange = (value: string) => {
    setFunnleOsValue(value);
    getFunnelData(value);
  };

  const getSepIndex = (name: string) => {
    const index = stepOptions?.findIndex((item: any) => item?.value === name);
    return index ? index + 1 : 1;
  };

  const getSepItem = (name: string) => stepOptions?.find((item: any) => item?.value === name) || 0;

  const onMouseOverFunc = (step: any) => {
    setStepTootipData(step);
  };

  const highestLostRate = stepData.length === 0 ? 0 : stepData.reduce((max, obj) => (parseFloat(obj?.lost_rate) > parseFloat(max?.lost_rate) ? obj : max), stepData[0])?.lost_rate;

  // 实际渲染的数据和下载的数据
  const renderData = useMemo(() => stepData?.map((item: any) => {
    const itemObj = getSepItem(item?.stage_name);
    const stepIndex = getSepIndex(item?.stage_name);
    return {
      ...item,
      ...itemObj,
      stepIndex,
      date: rangeTime?.[1],
      avg_time: dataFormat({value: item?.avg_time || 0, formatRule: 'thousandsInit'}),
      device_count_msg: `${dataFormat({value: item?.device_count || 0, formatRule: 'thousandsInit'})} (${dataFormat({value: item?.conversion_rate, formatRule: 'percent1Decimal'})})`,
      textMsg: `${formatMessage({ id: 'funnel_step' })} ${stepIndex} ${itemObj?.text || ''}`,
      lost_rate: dataFormat({value: item?.lost_rate, formatRule: 'percent1Decimal'}),
      highest_lost_rate: item?.lost_rate !== '' && parseFloat(item?.lost_rate) === parseFloat(highestLostRate)
    };
  }) || [], [stepData, stepOptions]);

  const handleDownloadFunc = () => {
    const downLoadTitle = formatMessage({ id: 'funnel_funnel' });
    const tableOption = {
      data: stepData,
      downloadData: renderData,
      option: [
        {
          key: 'date',
          header: formatMessage({ id: 'common_date' }),
        },
        {
          key: 'textMsg',
          header: formatMessage({ id: 'funnel_step' }),
        },
        {
          key: 'device_count_msg',
          header: formatMessage({ id: 'funnel_device_count_conversion' }),
        },
        // {
        //   key: 'avg_time',
        //   header: formatMessage({ id: 'funnel_avg_time' }),
        // },
        {
          key: 'lost_rate',
          header: formatMessage({ id: 'funnel_lost_percent' }),
        },
      ]
    };
    handleDownload(tableOption, downLoadTitle);
  };


  return (
    <CardSlot
      className="dbd-funnel"
      title={
        <div className="dbd-funnel-title">
          <div className="dbd-funnel-text">{formatMessage({ id: 'funnel_funnel' })}</div>
          <div className="dbd-funnel-desc">({rangeTime?.[1]})</div>
          <TipContext
            tipText={formatMessage({ id: 'funnel_funnel_expresion' })}
            className="dbd-funnel-icon"
          />
        </div>
      }
      isEyes={true}
      hiddenDownload={stepData?.length === 0}
      onDownload={handleDownloadFunc}
    >
      {/* end */}
      <div className="dbd-funnel-filter">
        {
          (pageType !== 'pc' && !isPoeDemo) && <Segment
            value={funnelOsValue}
            onChange={(value: any) => funnelOsValueChange(value)}
            options={ [
              { text: formatMessage({ id: 'funnel_total' }), value: 'total' },
              { text: 'Android', value: 'android' },
              { text: 'IOS', value: 'ios' },
            ]}
          />
        }
      </div>
      <Abnormal
        style={{ height: '400px', background: '#fff' }}
        component={<div className="dbd-funnel-context">
          <div className="funnel-context-tr">
            <div className="funnel-context-th">{formatMessage({ id: 'funnel_step' })}</div>
            <div className="funnel-context-th">{formatMessage({ id: 'funnel_device_count_conversion' })}</div>
            <div className="funnel-context-th"></div>
            <div className="funnel-context-th">{formatMessage({ id: 'funnel_lost_percent' })}</div>
            {/* <div className="funnel-context-th">{formatMessage({ id: 'funnel_avg_time' })}</div> */}
          </div>
          {renderData?.map((item: any, i: any) => (
            <div className={`${stepData?.length > 10 ? "funnel-other-height" : "funnel-ten-height"} funnel-context-tr`}
              key={i + item?.textMsg}
              onMouseOver={() => onMouseOverFunc({ ...item, stepIndex: `${formatMessage({ id: 'funnel_step' })} ${item?.stepIndex}` })}
            >
              <div className="funnel-context-td td-first">
                {/* <span className="">{item?.textMsg || ''}</span> */}
                <TextBubbles text={item?.textMsg || ''} className="text-title" />
              </div>
              <div className="funnel-context-td td-center">
                <div
                  className={`funnel-bg`}
                  style={{ width: `${item?.conversion_rate * 100}%` }}
                >
                </div>
                <div className='funnel-text'>{item?.device_count_msg}</div>
              </div>
              {/* <div className="funnel-context-td td-end">{item?.avg_time}</div> */}
              <div className="funnel-context-td td-end">
                <div className={`funnel-text ${item?.highest_lost_rate ? 'funnel-text-red funnel-text-bold' : ''}`}>{item?.lost_rate}</div>
              </div>
              {/* 气泡 */}
              <div className="funnel-context-bubble">
                <div className="bubble-title">{stepTootipData?.stepIndex} {stepTootipData?.text || ''}</div>
                <div className="bubble-flex">
                  <div className="bubble-text">{formatMessage({ id: 'funnel_device_count_conversion' })}</div>
                  <div className="bubble-num">{dataFormat({value: stepTootipData?.device_count || 0, formatRule: 'thousandsInit'})} ({dataFormat({value: stepTootipData?.conversion_rate, formatRule: 'percent1Decimal'})})</div>
                </div>
                {/* <div className="bubble-flex">
                  <div className="bubble-text">{formatMessage({ id: 'funnel_avg_time' })}</div>
                  <div className="bubble-num">{stepTootipData?.avg_time}</div>
                </div> */}
              </div>
            </div>
          ))}
        </div>}
        isLoading={loading}
        isError={error}
        isNoData={stepData?.length === 0}
      />

    </CardSlot>
  );
};

export default FunnelCard;
